import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-transport-medicalise',
  imports: [RouterOutlet],
  templateUrl: './main-transport-medicalise.component.html',
  styleUrl: './main-transport-medicalise.component.scss'
})
export class MainTransportMedicaliseComponent {}
